import React, { useState, useEffect } from 'react';

const Actionforsuperadmincomponent = (props) => {
  const email = localStorage.getItem('email') || '';
  const vendorKey = email.split('@')[0];

  const getStatusFromProps = () => {
    const participation = props.data.indent.vendors_participation;
    if (participation && participation[vendorKey]) {
      return participation[vendorKey];
    }
    return 'pending';
  };

  const [status, setStatus] = useState(getStatusFromProps());

  useEffect(() => {
    const updatedStatus = getStatusFromProps();
    setStatus(updatedStatus);
  }, [props.data.indent.vendors_participation]);

  const handleAccept = async (e) => {
    e.stopPropagation();
    // const ok = await props.context.componentParent.onClickacceptparticipation(props);
        const ok = await props.context.componentParent.acceptindent(props);

    if (ok !== false) setStatus('accepted');
  };

  const handleDecline = async (e) => {
    e.stopPropagation();
    const ok = await props.context.componentParent.rejectindent(props);
    if (ok !== false) setStatus('declined');
  };

  const handleBidNow = (e) => {
    e.stopPropagation();
    props.context.componentParent.onClickbiddetails(props);
  };
  const indent = props.data.indent;
  const isDisabled =  indent.vendorquotes  && indent.vendorquotes.some(e => e.vendor_email_id === localStorage.getItem("email"));

  const buttonStyle = {
    base: {
      color: '#fff',
      border: 'none',
      padding: '4px 14px',
      fontSize: '13px',
      fontWeight: 500,
      borderRadius: '5px',
      lineHeight: 1.4,
      cursor: 'pointer',
    },
    primary: {
      backgroundColor: '#00c7b1',
    },
    danger: {
      backgroundColor: '#e74c3c',
    },
  };
  const buttonStyle1 = {
    base: {
        marginRight:'9px',
      color: '#fff',
      border: 'none',
      padding: '4px 18px',
      fontSize: '13px',
      fontWeight: 500,
      borderRadius: '5px',
      lineHeight: 1.4,
      cursor: 'pointer',
    },
    primary: {
      backgroundColor: '#00c7b1',
    },
    danger: {
      backgroundColor: '#e74c3c',
    },
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        gap: '8px',
        minWidth: '170px',
      }}
    >
     {isDisabled?'':
        <>
        <button
  onClick={handleAccept}
  title="Approve"
  className="vendor-approve-btn"
>
  Approve
</button>
<button
  onClick={handleDecline}
  title="Decline"
  className="vendor-reject-btn"
>
  Reject
</button>

        </>}
      
    </div>
  );
};

export default Actionforsuperadmincomponent;